import React from 'react';

import { useTranslation } from 'react-i18next';
import { useDialog } from '@cnx-saas/common-fe';
import { useSnackbar } from '@cnx-saas/snackbar';
import { useSendInvitationMutation } from '../../../api/tenant/mutations/send-invitation';
import { InviteUserForm } from '../forms/InviteUserForm';

export function useInviteUser() {
  const { t } = useTranslation();

  const { openDialog, closeDialog } = useDialog();
  const [sendInvitation] = useSendInvitationMutation();
  const { addAlert } = useSnackbar();

  function openInviteUserFormDialog(onInviteUsers: () => void) {
    const id = 'invite-user-dialog';
    openDialog({
      id,
      title: t('userManagement.form.invite.title', {
        defaultValue: 'Invite Users',
      }),
      content: (
        <InviteUserForm
          onClose={() => closeDialog(id)}
          onSubmit={async (invitedUsers) => {
            const { data } = await sendInvitation({
              variables: {
                details: {
                  userType: invitedUsers.accountType,
                  emails: invitedUsers.emails,
                },
              },
            });
            if (data?.sendInvitation.message !== 'ok') {
              addAlert({
                type: 'error',
                children: data?.sendInvitation.message,
              });
            } else {
              addAlert({
                type: 'success',
                children: t('userManagement.form.invite.success', {
                  defaultValue: 'Invitation has been sent',
                }),
              });
              closeDialog(id);
            }
            onInviteUsers();
          }}
        />
      ),
      fitsContent: true,
    });
  }
  return { openInviteUserFormDialog };
}
